import { createContext } from '@lit/context'
import { type Producer } from '../util/api'

export const agentContext = createContext<Producer | undefined>(Symbol('agent'))
